import type { LookupSchemaFieldOption } from './lookup-schema-setup-types';
import styles from './LookupTool.module.css';

const REQUIRED_PLACEHOLDER = 'Select a field…';
const OPTIONAL_PLACEHOLDER = 'None';

interface LookupSchemaMappingSelectProps {
  id: string;
  label: string;
  hint: string;
  value: string;
  options: LookupSchemaFieldOption[];
  onChange: (value: string) => void;
  optional?: boolean;
}

export const LookupSchemaMappingSelect = ({
  id,
  label,
  hint,
  value,
  options,
  onChange,
  optional = false,
}: LookupSchemaMappingSelectProps) => {
  const placeholder = optional ? OPTIONAL_PLACEHOLDER : REQUIRED_PLACEHOLDER;

  return (
    <label className={styles.mappingField} htmlFor={id}>
      <strong>{label}</strong>
      <small>{hint}</small>
      <select
        id={id}
        value={value}
        onChange={event => onChange(event.target.value)}
        required={!optional}>
        <option value="">{placeholder}</option>
        {options.map(option => (
          <option key={option.name} value={option.name}>
            {option.name} ({option.type})
          </option>
        ))}
      </select>
    </label>
  );
};
